(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-assistant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SEL = '[data-fs-bot]';

    function init(root) {
      const el = root.matches && root.matches(SEL) ? root : root.querySelector(SEL);
      if (!el || el.dataset.ready === 'true') return;

      const configEl = el.querySelector('[data-fs-bot-config]');
      if (!configEl) return;

      let cfg;
      try {
        cfg = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      const launcher = el.querySelector('[data-fs-bot-launcher]');
      const panel = el.querySelector('[data-fs-bot-panel]');
      const closeBtn = el.querySelector('[data-fs-bot-close]');
      const log = el.querySelector('[data-fs-bot-log]');
      const chips = el.querySelector('[data-fs-bot-chips]');
      const form = el.querySelector('[data-fs-bot-form]');
      const input = el.querySelector('[data-fs-bot-input]');

      el.dataset.ready = 'true';
      let greeted = false;

      const scroll = () => {
        log.scrollTop = log.scrollHeight;
      };

      function addMessage(text, who) {
        const div = document.createElement('div');
        div.className = 'fs-bot__msg fs-bot__msg--' + who;
        div.textContent = text;
        log.appendChild(div);
        scroll();
        return div;
      }

      function addContactMessage() {
        const div = document.createElement('div');
        div.className = 'fs-bot__msg fs-bot__msg--bot';
        div.textContent = cfg.noMatch + ' ';
        const link = document.createElement('a');
        link.href = cfg.contactUrl;
        link.textContent = cfg.contactLabel;
        div.appendChild(link);
        log.appendChild(div);
        scroll();
      }

      function addResults(products) {
        const wrap = document.createElement('div');
        wrap.className = 'fs-bot__results';
        for (const p of products) {
          const a = document.createElement('a');
          a.className = 'fs-bot__result';
          a.href = p.url;
          if (p.image) {
            const img = document.createElement('img');
            img.src = p.image;
            img.alt = '';
            // Eager on purpose: inside the scrollable chat log a lazy image
            // never enters the viewport check and stays blank. ~10 KB each.
            img.loading = 'eager';
            img.width = 46;
            img.height = 58;
            a.appendChild(img);
          }
          const box = document.createElement('span');
          const t = document.createElement('span');
          t.className = 'fs-bot__result-title';
          t.textContent = p.title;
          box.appendChild(t);
          if (p.price) {
            const pr = document.createElement('span');
            pr.className = 'fs-bot__result-price';
            pr.textContent = p.price;
            box.appendChild(pr);
          }
          a.appendChild(box);
          wrap.appendChild(a);
        }
        log.appendChild(wrap);
        scroll();
      }

      /** Scores a query against a topic's comma-separated keywords. */
      function matchTopic(query) {
        const q = query.toLowerCase();
        let best = null;
        let bestScore = 0;
        for (const topic of cfg.topics) {
          const words = (topic.keywords || '')
            .toLowerCase()
            .split(',')
            .map((w) => w.trim())
            .filter(Boolean);
          let score = 0;
          for (const w of words) if (q.includes(w)) score += w.length;
          if (score > bestScore) {
            bestScore = score;
            best = topic;
          }
        }
        return best;
      }

      async function searchProducts(query) {
        const url =
          cfg.searchUrl +
          '?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=4';
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('search failed');
        const data = await res.json();
        const products =
          (data.resources && data.resources.results && data.resources.results.products) || [];
        return products.map((p) => ({
          title: p.title,
          url: p.url,
          image: thumb(p.featured_image ? p.featured_image.url : p.image, productHandle(p)),
          price: money(p.price),
        }));
      }

      function productHandle(product) {
        if (product.handle) return product.handle;
        const match = (product.url || '').match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
      }

      function cropForHandle(handle) {
        const groups = cfg.imageCrops || {};
        if ((groups.portrait || []).includes(handle)) return [42, 42, 884, 1251];
        if ((groups.landscape || []).includes(handle)) return [42, 42, 1251, 884];
        if ((groups.palmistry || []).includes(handle)) return [16, 16, 885, 1251];
        if ((groups.leopard || []).includes(handle)) return [120, 115, 1933, 2698];
        return null;
      }

      /** Shopify's CDN resizes on demand — no point pulling a 969px original
          into a 46px thumbnail. */
      function thumb(url, handle) {
        if (!url) return '';
        const imageUrl = new URL(url, window.location.origin);
        const crop = cropForHandle(handle);
        if (crop) {
          imageUrl.searchParams.set('crop', 'region');
          imageUrl.searchParams.set('crop_left', crop[0]);
          imageUrl.searchParams.set('crop_top', crop[1]);
          imageUrl.searchParams.set('crop_width', crop[2]);
          imageUrl.searchParams.set('crop_height', crop[3]);
        }
        imageUrl.searchParams.set('width', '120');
        return imageUrl.toString();
      }

      /** suggest.json returns a bare decimal string like "19.99". */
      function money(value) {
        const n = parseFloat(value);
        if (!isFinite(n)) return '';
        try {
          return new Intl.NumberFormat(cfg.locale || 'de', {
            style: 'currency',
            currency: cfg.currency || 'EUR',
          }).format(n);
        } catch (e) {
          return value;
        }
      }

      async function respond(query) {
        const topic = matchTopic(query);
        if (topic) {
          addMessage(topic.answer, 'bot');
          return;
        }

        const thinking = addMessage(cfg.thinkingText, 'bot');
        try {
          const products = await searchProducts(query);
          thinking.remove();
          if (products.length) {
            addMessage(cfg.searchIntro, 'bot');
            addResults(products);
          } else {
            addMessage(cfg.searchEmpty, 'bot');
            addContactMessage();
          }
        } catch (e) {
          thinking.remove();
          addContactMessage();
        }
      }

      function buildChips() {
        for (const button of chips.querySelectorAll('[data-fs-bot-chip]')) {
          const topic = cfg.topics[Number(button.dataset.fsBotChip)];
          if (!topic) continue;
          button.addEventListener('click', () => {
            addMessage(topic.label, 'user');
            addMessage(topic.answer, 'bot');
          });
        }
      }

      function open() {
        panel.hidden = false;
        el.dataset.open = 'true';
        launcher.setAttribute('aria-expanded', 'true');
        if (!greeted) {
          greeted = true;
          addMessage(cfg.greeting, 'bot');
          buildChips();
        }
        input.focus();
      }

      function close() {
        panel.hidden = true;
        el.dataset.open = 'false';
        launcher.setAttribute('aria-expanded', 'false');
        launcher.focus();
      }

      launcher.addEventListener('click', () => (panel.hidden ? open() : close()));
      closeBtn.addEventListener('click', close);

      document.addEventListener('shopify:block:select', (event) => {
        if (event.target instanceof Element && el.contains(event.target)) open();
      });

      document.addEventListener('shopify:section:select', (event) => {
        if (event.target instanceof Element && event.target.contains(el)) open();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !panel.hidden) close();
      });

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const q = input.value.trim();
        if (!q) return;
        addMessage(q, 'user');
        input.value = '';
        respond(q);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target instanceof Element) init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fs-legal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(scope) {
      const buttons = (scope || document).querySelectorAll('[data-fs-cookie-prefs]');
      if (!buttons.length) return;

      // Only offer the control if this storefront actually has a consent banner
      // to reopen — otherwise the button would be a dead end.
      const api = window.privacyBanner;
      const canOpen = api && typeof api.showPreferences === 'function';

      buttons.forEach((btn) => {
        if (btn.dataset.ready === 'true') return;
        btn.dataset.ready = 'true';
        if (!canOpen) return;
        btn.hidden = false;
        btn.addEventListener('click', () => {
          try {
            api.showPreferences();
          } catch (e) {
            /* banner unavailable — leave the page untouched */
          }
        });
      });
    }

    function boot() {
      init(document);
      // The privacy banner script can arrive after DOMContentLoaded.
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (window.privacyBanner || tries > 20) {
          clearInterval(timer);
          document.querySelectorAll('[data-fs-cookie-prefs]').forEach((b) => {
            b.dataset.ready = '';
          });
          init(document);
        }
      }, 300);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target instanceof Element) init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
